/** @module Enums */ /** typedoc */

export enum UnavailabilityEnum {
    Default = 'Default',
    FileIsUnderMinimumDuration = 'FileIsUnderMinimumDuration',
    FileIsOverMaximumDuration = 'FileIsOverMaximumDuration',
    OverCompressed = 'OverCompressed',
    FeatureNotSupported = 'FeatureNotSupported',
    Unauthorized = 'Unauthorized',
    AlreadyMastered = 'AlreadyMastered',
    CurrentlyMastering = 'CurrentlyMastering',
    ExternalTrackNotFound = 'ExternalTrackNotFound',
    ExternalAccountNotValidated = 'ExternalAccountNotValidated',
    FileIsOverMaximumSize = 'FileIsOverMaximumSize',
    ExternalAccountOutOfMinutes = 'ExternalAccountOutOfMinutes',
    UnavailableForRelease = 'UnavailableForRelease'
}
